import React from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import classNames from 'classnames';

export const Image = ({ onClick, className, src, onEdit, onDelete }) => {
    return (
        <div onClick={onClick} className={classNames('img', className)}>
            {onEdit || onDelete ? (
                <div className={'img__mask'}>
                    {onEdit ? (
                        <div className={'img__mask-info'}>
                            <EditOutlined onClick={onEdit} />
                        </div>
                    ) : null}
                    {onDelete ? (
                        <div className={'img__mask-info'}>
                            <DeleteOutlined onClick={onDelete} />
                        </div>
                    ) : null}
                </div>
            ) : null}
            <img alt="" src={src} width={'100%'} height={'100%'} />
        </div>
    );
};
